define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var TemplateClass = require('class/template.class');

    TemplateClass.prototype.replace = function() {
        var view, params;

        var source = this.toString().replace(/\[([A-Za-z\-_0-9]+)(?:\((.+?)\)|)]/gm,
            function(match, replacerName, replacerParams) {
                var dTag;
                if (dTag = Playtech.Variables.dynamicTags[replacerName]) {
                    return dTag;
                }
                return '<span class="_replacer" data-params="' + (replacerParams || '') + '">' + replacerName
                    + '</span>';
            });

        this._setWrapperInnerHtml(source);
        var elements = this._wrapper.querySelectorAll('._replacer');

        [].forEach.call(elements, function(node) {
            var replacerName = node.innerHTML;
            params = node.dataset.params ? node.dataset.params.split(',') : [];
            if (this._view.replacers[replacerName]) {
                view = new this._view.replacers[replacerName]($.extend({}, this.data, {
                    name: replacerName,
                    params: params
                }));
                this._view.childViews.push(view);
                node.parentNode.replaceChild(view.render.apply(view, params).el, node);
            }
        }.bind(this));

        return this.getNodes();
    };

    module.exports = TemplateClass;
});
